import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { authAPI } from "../services/authAPI";
import { validateEmail, formatAPIError } from "../utils/validation";
import Header from "../components/layout/Header";
import "./styles/ForgotPassword.css";

const ForgotPassword = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({ email: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (error) setError("");
  };

  const validateForm = () => {
    const emailError = validateEmail(formData.email);
    if (emailError) return emailError;
    return "";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const emailError = validateForm();
    if (emailError) {
      setError(emailError);
      return;
    }

    setLoading(true);
    setError("");

    try {
      const response = await authAPI.forgotPassword({ email: formData.email });

      navigate("/reset-password", {
        state: {
          email: formData.email,
          message: response.data.message || "OTP sent for password reset",
        },
      });
    } catch (err) {
      const errorMessage = formatAPIError(err);
      if (errorMessage.includes("User not found")) {
        setError("No account found with this email address");
      } else {
        setError(errorMessage);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />

      <div className="fp-page">
        <div className="fp-card">
          <div className="fp-top">
            <div className="fp-icon">
              {/* inline mail icon */}
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path
                  d="M4 7.5A2.5 2.5 0 0 1 6.5 5h11A2.5 2.5 0 0 1 20 7.5v9A2.5 2.5 0 0 1 17.5 19h-11A2.5 2.5 0 0 1 4 16.5v-9Z"
                  stroke="#2563EB"
                  strokeWidth="2"
                />
                <path
                  d="M5.5 7l6.5 5 6.5-5"
                  stroke="#2563EB"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>

            <h1 className="fp-title">Forgot Password?</h1>
            <p className="fp-subtitle">No worries, we'll send you reset instructions</p>
          </div>

          <div className="fp-body">
            {error && <div className="fp-alert fp-alert--error">{error}</div>}

            <form onSubmit={handleSubmit} className="fp-form">
              <div className="fp-field">
                <label className="fp-label">Email Address</label>
                <input
                  className={error ? "fp-input fp-input--error" : "fp-input"}
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Enter your email"
                  disabled={loading}
                />
              </div>

              <button className="fp-btn fp-btn--primary" type="submit" disabled={loading}>
                {loading ? "Sending..." : "Send Reset Link"}
              </button>
            </form>

            <div className="fp-footer">
              <Link to="/login" className="fp-backlink">
                <span className="fp-backicon">←</span>
                Back to Login
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;
